function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Notifications");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Styleguide",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Buttons--Copy",
  transform: "translate(-626.000000, -147.000000)"
}, React.createElement("g", {
  id: "Black",
  transform: "translate(287.000000, 144.000000)"
}, React.createElement("g", {
  id: "Notifications",
  transform: "translate(336.000000, 0.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fillOpacity: 0,
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("path", {
  d: "M12.1662319,9.4 C12.6249588,9.4 13,9.7581722 13,10.2 C13,10.6409288 12.6259812,11 12.1646056,11 L3.83539442,11 C3.37376094,11 3,10.6418278 3,10.2 C3,9.75907124 3.37329069,9.4 3.8337681,9.4 C4.06286237,9.4 4.25,9.2207578 4.25,8.99965134 L4.25,6.59984988 C4.25,4.6108582 5.92893219,3 8,3 C10.0715232,3 11.75,4.6117077 11.75,6.59984988 L11.75,8.99965134 C11.75,9.22214766 11.9363534,9.4 12.1662319,9.4 Z M6.54166667,11.4 L9.45833333,11.4 C9.45833333,12.1731986 8.80541525,12.8 8,12.8 C7.19458475,12.8 6.54166667,12.1731986 6.54166667,11.4 Z",
  id: "Shape",
  fill: "#1E1F20"
})))));

var SvgNotifications = function SvgNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifications.f0d1abd2.svg";
export { ForwardRef as ReactComponent };